/**
 * Identity Server Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AuthenticationMethodConfigurationViewModel { 
    organizationId?: number;
    allowSecondFactor?: boolean;
    enforceSecondFactor?: boolean;
    allowMultipleFirstFactors?: boolean;
    allowMultipleSecondFactors?: boolean;
    passcode?: number;
    passcodeViaSms?: boolean;
    passcodeViaEmail?: boolean;
    softToken?: number;
    enforcePush?: boolean;
    staticCode?: number;
    hardwareToken?: number;
    yubikey?: number;
    fidoToken?: number;
}

